import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import CustomFieldsTable from './shared/custom-fields-table';
import { useCustomFields } from './hooks/custom-fields.hook';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { ATTACH_CUSTOM_FIELD } from '../../../constants/custom-field-endpoint';
import AddCustomFieldCanvas from './add-custom-field-canvas';

const CustomFieldCanvas = React.forwardRef(({ entityInfo,onCloseRefresh, updateCustomFields }, ref) => {
    const addCustomFieldCanvasRef = useRef(null);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const { customFields,attachedFields, getCustomFields,getDonorCustomField,  requestLoader, filters,register, deleteCustomField, archiveErrorMessage } = useCustomFields();
    const { handleSubmit, control, watch, reset } = useForm({
        defaultValues: {
            fields: []
        }
    });
    const formFields = watch();
    const [errorMessage, setErrorMessage] = useState("");

    const handleClose = () => {
        if(onCloseRefresh){
            onCloseRefresh();
        }
        setShow(false)
    };
    const handleShow = () => {
        // getCustomFields();
        setShow(true);
    }

    const attachCustomField = () => {
        console.log(formFields.fields)
        setLoader(true);
        setErrorMessage("");
        axios.post(`${ATTACH_CUSTOM_FIELD}${entityInfo?.entity_id}`, formFields.fields)
            .then((res) => {
                setLoader(false);
                if (res?.data?.status) {
                    updateCustomFields();
                    handleClose();
                } else {
                    setErrorMessage(res?.data?.message);
                }
            }).catch((error) => {
                setLoader(false);
                setErrorMessage("Failed to attach fields");
            })
    }

    useEffect(() => {
        if (entityInfo?.entity_id) {
            if(entityInfo?.entity_type === 'donor'){
                getDonorCustomField(entityInfo?.entity_id);
            }else{
                getCustomFields(entityInfo?.entity_id);
            }
            
        }
    }, [entityInfo?.entity_id,filters?.field_is_delete, filters?.field_type]);

    useEffect(() => {
        if(attachedFields?.length > 0){
            reset({
                fields:attachedFields
            })
        }
    }, [attachedFields])

    useImperativeHandle(ref, () => {
        return {
            handleShow: handleShow,
            customFields:customFields
        };
    });

    return (
        <>
            {/* <Button variant="primary" onClick={handleShow}>
                Launch
            </Button> */}
            <Offcanvas backdrop="static" show={show} onHide={handleClose} placement='end'>
                <Offcanvas.Header className='pt-3 pb-3'>
                    <Offcanvas.Title>Attach Custom Fields</Offcanvas.Title>
                    <button 
                    disabled={requestLoader || loader}
                    onClick={() => addCustomFieldCanvasRef.current.handleShow()}
                    className='btn btn-outline-primary mb-0'><i className="fa-solid fa-plus me-2"></i>Add New Field</button>
                </Offcanvas.Header>
                < hr className='m-0' />

                <Offcanvas.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Filters</h6>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                                <select {...register("field_is_delete")} className="form-select">
                                <option value="0">Active</option>
                                <option value="1">Archived</option>
                            </select>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                                <select {...register("field_type")} className="form-select">
                                <option value="">All</option>
                                <option value="text">Text</option>
                                <option value="number">Number</option>
                                <option value="date">Date</option>
                                <option value="dropdown">Dropdown</option>
                                <option value="checkbox">Checkbox</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div className='mt-3 row position-relative' style={{
                        height: '300px' 
                    }}>
                        
                        <div className='col-12'>
                            <CustomFieldsTable
                                control={control}
                                addCustomFieldCanvasRef={addCustomFieldCanvasRef}
                                archiveErrorMessage={archiveErrorMessage}
                                entityInfo={entityInfo}
                                attachField={entityInfo?.entity_type === 'donor' ? false : true}
                                customFields={customFields}
                                getCustomFields={() =>
                                    entityInfo?.entity_type === 'donor' ? getDonorCustomField() : getCustomFields()
                                }
                                loader={loader}
                                deleteCustomField={deleteCustomField}
                            />
                            {errorMessage ? <p className='text-danger'>{errorMessage}</p> : ''}
                        </div>
                    </div>
                    <div style={{
                        backgroundColor:'rgb(250 250 250)',
                        borderTop:'1px solid rgb(228 228 231)',
                    }} className='position-absolute bottom-0 p-3 start-0 w-100 d-flex justify-content-between align-items-center'>
                            <button 
                            disabled={requestLoader || loader}
                            onClick={handleClose} type='button' className='mb-0 me-2 btn btn-outline-secondary'>{
                                entityInfo?.entity_type === 'donor' ?  'Close' : 'Cancel'
                            }</button>
                            {
                                entityInfo?.entity_type !== 'donor' ? 
                                <button 
                                disabled={requestLoader || loader}
                                onClick={attachCustomField} type='button' 
                                className={`${requestLoader ? 'position-relative button--loading' : ''} mb-0 btn btn-outline-primary`}
                                >Save</button> : ''
                            }
                            
                        </div>
                </Offcanvas.Body>
            </Offcanvas>

            <AddCustomFieldCanvas 
            refreshData={() => {
                if(entityInfo?.entity_type === 'donor'){
                    getDonorCustomField(entityInfo.entity_id);
                }else{
                    getCustomFields(entityInfo.entity_id);
                }
                
                if(updateCustomFields){
                    updateCustomFields();
                }
            }} 
            entity_type={entityInfo?.entity_type}
            entity_id={entityInfo?.entity_type !== 'donor' ? entityInfo?.entity_id : null}
            ref={addCustomFieldCanvasRef} />
        </>
    );
});

export default CustomFieldCanvas;